module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Search Results","articles_title":"Articles","questions_title":"Frequently Asked Questions"},"pt-BR":{"title":"Resultado da Pesquisa","articles_title":"Artigos","questions_title":"Dúvidas Frequentes / FAQ"}}')
  delete Component.options._Ctor
}
